// extracted by mini-css-extract-plugin
export var messageSideLeft = "_lm-1";
export var messageSideRight = "_lm-2";
export var subscribeToBackInStockBubbleContainer = "_lm-0";